<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="col-sm-6 grey-grad-bg"><br>
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h1 class="text-uppercase">{{ rewardItem.name }}</h1>
              <div class="description" v-html="rewardItem.description"></div>
              <br>
              <div class="row">
                <div class="col-md-3">
                  <select
                    class="form-control client-form-control input-lg"
                    v-model.number="cartItem.quantity"
                  >
                    <option disabled value="">Quantity</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                </div>
                <div class="col-md-9">
                  <select
                    class="form-control client-form-control input-lg"
                    v-if="itemSizes.length > 0"
                    v-model="cartItem.size"
                  >
                    <option disabled value="">Sizes</option>
                    <option
                      v-for="(size, index) in itemSizes" :key="index"
                      :val="size"
                      >
                      {{ size }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="clearfix"></div>
              <br>
              <div
                class="choose-color text-center"
                v-if="itemColors.length > 0"
              >
                <p>Choose the color</p>
                <div class="color-list">
                  <div
                    v-for="(color, index) in itemColors"
                    :key="index"
                    class="color-wrapper"
                    @click="setCartItemColor(color.name); setActive($event)"
                    >
                    <div
                      class="item-color"
                      :data-hex="color.hex">
                    </div>
                    <span class="text-uppercase">
                      {{ color.name }}
                    </span>
                  </div>
                  <!-- <div
                    v-for="(color, index) in itemColors"
                    :key="index"
                    class="item-color"
                    :data-hex="color.hex"
                    @click="setCartItemColor(color.name); setActive($event)"
                    >
                  </div> -->
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="clearfix"></div>
              <a
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="goCartItems"
              >
                Add to Cart
              </a>
              <a
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="goRewardCatalog"
              >
                Back
              </a>
              <br>
              <br>
              <br>
            </div>
          </div>
        </div>

        <div class="col-sm-6 redeem-sec">
          <div class="row max-height">
            <div class="col-md-8 col-md-offset-2 text-center text-uppercase max-height">
              <div class="reward-image-container max-height">
                <img :src="rewardItem.image.url" class="" :alt="rewardItem.name">
              </div>
                <!-- <img :src="rewardItem.image.url" class="img-responsive" :alt="rewardItem.name"> -->
              <!-- <img src="../../../assets/images/rewards/alexa-lrg.jpg" class="img-responsive"> -->
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'RewardDetail',
  props: ['rewardItem'],
  data () {
    return {
      cartItem: {
        item: this.rewardItem._id,
        name: this.rewardItem.name,
        imageUrl: this.rewardItem.image.url,
        quantity: '1',
        size: '',
        color: '',
        points: this.rewardItem.points
      }
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    itemSizes () {
      return [
        ...this.rewardItem.sizes,
        ...this.rewardItem.customSizes
      ] || []
    },
    itemColors () {
      return [
        ...this.rewardItem.colors.map(color => JSON.parse(color)),
        ...this.rewardItem.customColors
      ] || []
    }
  },
  mounted () {
    document
      .querySelectorAll('.item-color')
      .forEach(el => {
        el.style.backgroundColor = `#${el.dataset.hex}`
      })
  },
  methods: {
    ...mapActions('cartRewardItem', [
      'clientAddCartRewardItem'
    ]),
    setCartItemColor (color) {
      this.cartItem.color = color
    },
    goCartItems (item) {
      const errors = this.validate()
      if (errors.length > 0) {
        errors.forEach((error, idx) => {
          setTimeout(() => {
            this.$bus.emit('notify', { message: error, type: 'danger' })
          }, 500 * idx)
        })
        return
      }
      this.clientAddCartRewardItem({
        ...this.cartItem,
        userLoyaltyProgram: this.user.userLoyaltyProgram._id
      })
        .then((response) => {
          this.$bus.emit('swapComponent', { component: 'cart-items' })
        })
    },
    goRewardCatalog () {
      this.$bus.emit('swapComponent', { component: 'reward-catalog' })
    },
    setActive (event) {
      const prevActive = document.querySelector('.active-color')
      if (prevActive) prevActive.classList.remove('active-color')
      event.target.classList.add('active-color')
    },
    validate () {
      let errors = []
      if (this.itemColors.length > 0 && this.cartItem.color === '') errors.push('Select a color')
      if (this.itemSizes.length > 0 && this.cartItem.size === '') errors.push('Select a size')
      return errors
    }
  }
}
</script>

<style scoped>
.reward-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.reward-image-container img {
  max-width: 100%;
  height: 60vh;
}

.max-height {
  height: 100%;
}

.active-color {
  opacity: .8;
  border: 1px solid rgba(58,58,58,.60);
  -webkit-box-shadow: 0px 0px 5px rgba(58,58,58,0.75);
  box-shadow: 0px 0px 8px rgba(58,58,58,0.75);
}

.color-list {
  padding: 5px 10px;
  display: flex;
  display: -webkit-flex;
  -webkit-flex-wrap: wrap;
  justify-content: space-around;
  flex-flow: row wrap;
}

.color-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  max-width: 60px;
}

.item-color {
  /* margin-top: 10px;
  margin-right: 10px; */
  border: 1px solid #3a3a3a;
  border-radius: 5px;
  width: 50px;
  height: 50px;
  line-height: 46px;
}

.item-color:hover {
  cursor: pointer;
  opacity: .9;
  border: 1px solid rgba(58,58,58,.60);
  -webkit-box-shadow: 0px 0px 5px rgba(58,58,58,0.75);
  box-shadow: 0px 0px 5px rgba(58,58,58,0.75);
}

.choose-color {
  display: flex;
  flex-direction: column;
  background-color:  #FFF;
  padding: 15px;
  color: #464646;
  margin-bottom: 15px;
}

.choose-color a{
  width: 100%;
  border:2px solid transparent;
  display: inline-block;
}

.choose-color a:hover{
  border:2px solid rgba(7,175,255,1.00);
}

.grey-color{
  background-color:#666;
}

.description {
  max-height: 200px;
  overflow-y: auto;
  padding: 5px;
  background-color: #fff;
  color: initial;
}
</style>
